import { makeStyles, Theme } from '@material-ui/core'

export const useToggleButtonGroupStyles = makeStyles<Theme>((theme) => ({
  root: {
    '&&': {
      backgroundColor: theme.palette.grey[300],
    },
  },
}))
